import type { Styles } from 'src/theme/themes';

export const styles = {
  tableContainer: (theme) => ({
    width: '100%',
    boxShadow: '0px 4px 23px 0px #00000014',
    border: '1px solid',
    borderColor: theme.colors.neutral[100],
  }),
  loadingCell: {
    textJustify: 'center',
    textAlign: 'center',
    p: 0,
    height: 48,
  },
} satisfies Styles;
